<tax-page-header titleText="login.title"></tax-page-header>

<div class="ui-kit-white-card">
  <tax-login-menu></tax-login-menu>

  <tax-login-by-sms-form *ngIf="isFormPage" (smsSend)="setUserInfo($event)"></tax-login-by-sms-form>

  <tax-login-by-sms-authorize
    *ngIf="!isFormPage && userInfo"
    [userInfo]="userInfo"
    (confirmed)="login()"
  ></tax-login-by-sms-authorize>
</div>
